import React from 'react';
import PropTypes from 'prop-types';

const HiddenInput = ({ input }) => <input {...input} type="hidden" />;

HiddenInput.propTypes = {
  input: PropTypes.object,
};

HiddenInput.defaultProps = {
  input: {},
};

export default HiddenInput;
